module.exports = __webpack_public_path__ + "img/hr-puberty-decal-13.83c18588.png";